// remainingCreditMonths > 6 && (matchesFixzinsWindow || matchesTopRateImprovement)
import React, { useState, useContext, useEffect } from "react";
import axios from 'axios';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import de from "date-fns/locale/de";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'


import { Paper, Button, Box, TextField, InputAdornment, Tooltip } from "@material-ui/core";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import GetAppIcon from '@material-ui/icons/GetApp';

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';

import { capitalize } from "../../functions/GlobalHelpers"
import ArchiveStatsDialog from "./tools/ArchiveStatsDialog";
import { TOP_FIXED_RATE_DURATION_BY_KEY, TOP_FIXED_RATE_SETTINGS } from "./topConditionsConfig";
import { getAvailableSnoozeMenuOptions, isSnoozedNow } from "./snoozeHelpers";
import { updateCreditSnooze } from "./snoozeApi";

const useStyles = makeStyles((theme) => ({
  creditRow: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  filterBar: {
    marginBottom: theme.spacing(2)
  },
  snoozeBadge: {
  marginLeft: theme.spacing(1),
  color: "#999",
  fontSize: "0.75rem",
},
  creditRowSnoozed: {
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1),
  opacity: 0.70,
  backgroundColor: "#f5f5f5",
},
  inactiveCreditRow: {
    opacity: 0.55,
  },
  inactiveProfileHint: {
    marginLeft: theme.spacing(1),
  },
}));

const CreditsFiltered = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  let history = useHistory();
  const userContext = useContext(UserContext);
  const pageContext = useContext(PageContext);
  const [actionsMenuTarget, setActionsMenuTarget] = useState(null);
  const [creditForActions, setCreditForActions] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [agentFilter, setAgentFilter] = useState("");
  const [subtypeFilter, setSubtypeFilter] = useState("");
  const [archiveStatsOpen, setArchiveStatsOpen] = useState(false);
  const [isExcelDownloading, setIsExcelDownloading] = useState(false);
  const topFixedRateLabelByKey = TOP_FIXED_RATE_SETTINGS.reduce((acc, setting) => {
    acc[setting.key] = setting.label;
    return acc;
  }, {});

  const getRemainingMonths = (dateString) => {
    if (!dateString) {
      return null;
    }
    const targetDate = new Date(dateString);
    if (Number.isNaN(targetDate.getTime())) {
      return null;
    }
    const today = new Date();
    return (targetDate.getFullYear() - today.getFullYear()) * 12 + (targetDate.getMonth() - today.getMonth());
  };

  // Dual-Option-Mapping-Variante 
  // const getMatchingTopRateOptions = (remainingCreditMonths) => {
  //   const durationBySettingKey = TOP_FIXED_RATE_DURATION_BY_KEY;

  //   const candidates = Object.keys(durationBySettingKey)
  //     .map((key) => {
  //       const months = durationBySettingKey[key];
  //       const label = topFixedRateLabelByKey[key] || key;
  //       const rawRate = props.topConditions?.[key]?.value_numeric;
  //       const rate = parseFloat(rawRate);
  //       return { key, label, months, rate, distance: Math.abs(months - remainingCreditMonths) };
  //     })
  //     .filter((entry) => {
  //       return !Number.isNaN(entry.rate);
  //     });

  //   if (candidates.length === 0) {
  //     return null;
  //   }

  //   const nearestCandidates = [...candidates].sort((a, b) => {
  //     if (a.distance === b.distance) {
  //       return a.months - b.months;
  //     }
  //     return a.distance - b.distance;
  //   });

  //   const primary = nearestCandidates[0];
  //   const nextLonger = [...candidates]
  //     .filter((entry) => entry.months > primary.months)
  //     .sort((a, b) => a.months - b.months)[0] || null;

  //   return { primary, nextLonger };
  // };

  // Mapping-Variante: bester Topzins mit Laufzeit passend zur Restlaufzeit des Kredits
  const getMatchingTopRate = (remainingFixzinsMonths, remainingCreditMonths) => {
    const durationBySettingKey = TOP_FIXED_RATE_DURATION_BY_KEY;

    const candidates = Object.keys(durationBySettingKey)
      .map((key) => {
        const months = durationBySettingKey[key];
        const label = topFixedRateLabelByKey[key] || key;
        const rawRate = props.topConditions?.[key]?.value_numeric;
        const rate = parseFloat(rawRate);
        return { key, label, months, rate };
      })
      .filter((entry) => {
        if (Number.isNaN(entry.rate)) {
          return false;
        }
        return entry.months <= remainingCreditMonths;
      });

    if (candidates.length === 0) {
      return null;
    }

    // Sort by distance to remaining credit months, then by rate (prefer lower rate on tie)
    return [...candidates].sort((a, b) => {
      const distanceA = Math.abs(a.months - remainingCreditMonths);
      const distanceB = Math.abs(b.months - remainingCreditMonths);
      if (distanceA === distanceB) {
        return a.rate - b.rate; // tie-breaker: better rate wins
      }
      return distanceA - distanceB; // closer match to remaining credit months
    })[0];
  };


  const setCreditStatus = (status) => {
    const stats = creditForActions.stats;
    // remove null properties from stats
    Object.keys(stats).forEach(key => {
      if (stats[key] === null) {
        delete stats[key];
      }
    });
    const saveData = { ...creditForActions, stats: stats, status: status };

    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${creditForActions.id}`,
      data: saveData,
      method: 'put',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        props.getCredits();
        pageContext.setInfoMessage("Finanzierung wurde archiviert. Du findest sie rechts oben im Archiv-Tab.");
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("Finanzierung konnte nicht archiviert werden!");
      });
  }

  const setCreditSnooze = (mode) => {
    updateCreditSnooze(
      creditForActions,
      mode,
      userContext.getRequestAuthHeader()
    )
      .then(() => {
        props.getCredits();
        setActionsMenuTarget(null);
        pageContext.setInfoMessage("Anzeigestatus wurde aktualisiert.");
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("Anzeigestatus konnte nicht aktualisiert werden.");
      });
  }

  const downloadPotentialRefinancingExcel = () => {
    if (isExcelDownloading) {
      return;
    }

    const visibleCredits = getVisibleRefinancingCredits();
    const visibleCreditIds = visibleCredits.map((credit) => credit.id);
    if (visibleCreditIds.length === 0) {
      pageContext.setInfoMessage("Keine Kredite fuer den Excel Download vorhanden.");
      return;
    }

    setIsExcelDownloading(true);

    axios({
      url: `${process.env.REACT_APP_API_SERVICE_URL}/potentialrefinancing/excel`,
      method: "get",
      headers: userContext.getRequestAuthHeader(),
      responseType: "blob",
      params: {
        credit_ids: visibleCreditIds.join(","),
        show_snoozed: props.showSnoozedCredits ? 1 : 0,
        search_term: searchTerm,
        agent_filter: agentFilter,
        subtype_filter: subtypeFilter,
      },
    })
      .then((res) => {
        const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
        const downloadLink = document.createElement("a");
        const contentDisposition = res.headers["content-disposition"] || "";
        const filenameMatch = contentDisposition.match(/filename=\"?([^\";]+)\"?/);
        const filename = filenameMatch ? filenameMatch[1] : "potential_refinancing.xlsx";

        downloadLink.href = blobUrl;
        downloadLink.setAttribute("download", filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("Excel Download konnte nicht erstellt werden.");
      })
      .finally(() => {
        setIsExcelDownloading(false);
      });
  };


  const renderCredit = (credit) => {
    const isSnoozed = isSnoozedNow(credit);
    const isInactiveAdvisor = credit.user && credit.user.active === false;
    const formatDate = (dateString) => {
      if (!dateString) return "-";
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('de-DE', { year: 'numeric', month: 'long' });
      } catch (e) {
        return "-";
      }
    };

    const formatStats = () => {
      if (!credit.stats) return null;
      const stats = [];
      if (credit.stats.fixzins !== null && credit.stats.fixzins !== undefined) {
        stats.push(`Fixzins: ${credit.stats.fixzins}%`);
      }
      if (credit.stats.fixzins_end_date) {
        stats.push(`Fixzins bis: ${formatDate(credit.stats.fixzins_end_date)}`);
      }
      if (credit.stats.aufschlag_variabel !== null && credit.stats.aufschlag_variabel !== undefined) {
        stats.push(`Aufschlag variabel: ${credit.stats.aufschlag_variabel}%`);
      }
      if (credit.stats.credit_end_date) {
        stats.push(`Gesamtlaufzeit bis: ${formatDate(credit.stats.credit_end_date)}`);
      }
      return stats.length > 0 ? stats : null;
    };

    const statsText = formatStats();

    // Finanzierung wurde an Berater übergeben und Tippgeber hat keinen Zugriff mehr
    if (userContext.user.role === "tippgeber" && userContext.user.ID !== credit.user.id) {
      return <Paper key={credit.id} className={`${classes.creditRow} ${isInactiveAdvisor ? classes.inactiveCreditRow : ""}`}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={8} md={6}>
            <Typography className={classes.heading}>
              {credit.title}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {credit.type === "konsum" ? "Konsumkredit" : "Hypothekarkredit"}
              {credit.subtype && " - " + capitalize(credit.subtype)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="overline">
              Finanzierungsberater:{" "}
              {credit.user.name}
              {isInactiveAdvisor && (
                <span className={classes.inactiveProfileHint}>inaktives Profil</span>
              )}
            </Typography>
          </Grid>
        </Grid>
      </Paper>;
    }

    // alle anderen Fälle
    return <Paper key={credit.id} className={`${isSnoozed ? classes.creditRowSnoozed : classes.creditRow} ${isInactiveAdvisor ? classes.inactiveCreditRow : ""}`}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={8} md={6}>
          <Typography className={classes.heading}>
            {credit.title}
            {isSnoozed && (
              <span className={classes.snoozeBadge}>
                (ausgeblendet)
              </span>
            )}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {credit.type === "konsum" ? "Konsumkredit" : "Hypothekarkredit"}
            {credit.subtype && " - " + capitalize(credit.subtype)}
          </Typography>
          {statsText && statsText.length > 0 &&
            <Box style={{ marginTop: "8px" }}>
              <Typography variant="body2" color="textSecondary" style={{ fontSize: "0.85rem" }}>
                {statsText.join(" | ")}
              </Typography>
            </Box>
          }
        </Grid>
        <Grid item xs={4} md={3}>
          <Typography variant="overline">
            {credit.user.name}
            {isInactiveAdvisor && (
              <span className={classes.inactiveProfileHint}>inaktives Profil</span>
            )}
          </Typography>
          {credit.refinancingReason &&
            <Typography variant="body2" color="textSecondary" style={{ marginTop: "8px", fontSize: "0.85rem" }}>
              <strong>Umschuldung prüfen:</strong> {credit.refinancingReason}
            </Typography>
          }
        </Grid>
        <Grid item xs={6} md={2}>
          {credit.status === "draft" &&
            <Button size="small" onClick={() => {
              if (userContext.user.role === "tippgeber") {
                history.push("/antrag/" + credit.id);
              } else {
                history.push("/finanzierung/" + credit.id);
              }
            }}>
              öffnen
            </Button>
          }
        </Grid>
        <Grid item xs={2} md={1}>
          <IconButton
            aria-label="more"
            aria-controls="credit-menu"
            aria-haspopup="true"
            onClick={(e) => {
              setActionsMenuTarget(e.currentTarget)
              setCreditForActions(credit)
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Paper>;
  }

  if (props.credits.length === 0) {
    return (
      <Paper className={classes.creditRow}>
        <Typography align="center">
          Im Moment gibt es keine Finanzierungen in dieser Ansicht.
        </Typography>
      </Paper>
    );
  }
  var availableAgents = props.credits.map(credit => credit.user);
  // remove duplicates
  availableAgents = availableAgents.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
  // sort by name
  availableAgents.sort((a, b) => (a.name > b.name) ? 1 : -1);

  const getVisibleRefinancingCredits = () => {
    return props.credits.filter(credit => {
      // Only show hypothekar type
      if (credit.type !== "hypothekar")
        return false;
      if (isSnoozedNow(credit) && !props.showSnoozedCredits) {
        return false;
      }

      const fixzinsEndDate = credit.stats?.fixzins_end_date ? new Date(credit.stats.fixzins_end_date) : null;
      const sixMonthsFromNow = new Date();
      sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6);

      const matchesFixzinsWindow =
        fixzinsEndDate &&
        !Number.isNaN(fixzinsEndDate.getTime()) &&
        (fixzinsEndDate <= sixMonthsFromNow);

      const remainingFixzinsMonths = getRemainingMonths(credit.stats?.fixzins_end_date);
      const remainingCreditMonths = getRemainingMonths(credit.stats?.credit_end_date);
      const currentFixzins = parseFloat(credit.stats?.fixzins);

      const isRunningLoan =
        remainingFixzinsMonths !== null &&
        remainingCreditMonths !== null &&
        remainingCreditMonths > 0;

      const matchingTopRate =
        isRunningLoan && !Number.isNaN(currentFixzins)
          ? getMatchingTopRate(remainingFixzinsMonths, remainingCreditMonths)
          : null;

      const matchesTopRateImprovement =
        matchingTopRate !== null &&
        matchingTopRate.rate <= currentFixzins - 0.5;

      const hasAnyBetterTopRate = () => {
        if (remainingCreditMonths < 6 || currentFixzins === null || Number.isNaN(currentFixzins) || currentFixzins === 0) {
          return false;
        }
        const durationBySettingKey = TOP_FIXED_RATE_DURATION_BY_KEY;
        for (const key in durationBySettingKey) {
          const rawRate = props.topConditions?.[key]?.value_numeric;
          const rate = parseFloat(rawRate);
          if (!Number.isNaN(rate) && rate <= currentFixzins - 0.5) {
            return true;
          }
        }
        return false;
      };
      const hasAnySavingOption = hasAnyBetterTopRate();

      const isPureVariableRate =
        remainingCreditMonths >= 6 &&
        (currentFixzins === null || Number.isNaN(currentFixzins) || currentFixzins === 0);

      const fixzinsTimeMsg =
        remainingFixzinsMonths < 0
          ? `Der Fixzinszeitraum hat vor ${Math.abs(remainingFixzinsMonths)} Monaten geendet.`
          : `Der Fixzinszeitraum endet in ${remainingFixzinsMonths} Monaten.`;

      let refinancingReason = null;
      if (isPureVariableRate) {
        refinancingReason = `Rein variabel verzinst, Konditionen auf mögliche Umschuldung überprüfen.`;
      } else if (matchesFixzinsWindow) {
        refinancingReason = fixzinsTimeMsg;
      } else if (matchesTopRateImprovement) {
        const savingsAmount = (currentFixzins - matchingTopRate.rate).toFixed(2);
        refinancingReason = `Aktueller Fixzinssatz könnte um ${savingsAmount} (${matchingTopRate.label}) niedriger ausfallen.`;
      } else if (hasAnySavingOption) {
        refinancingReason = `Konditionen überprüfen, es könnte günstigere Fixzinssätze geben.`;
      }

      if (!((remainingCreditMonths > 6 && (matchesFixzinsWindow || matchesTopRateImprovement || hasAnySavingOption)) || isPureVariableRate)) {
        return false;
      }

      credit.refinancingReason = refinancingReason;

      if (agentFilter && credit.user.id !== agentFilter)
        return false;

      if (subtypeFilter && credit.subtype !== subtypeFilter)
        return false;

      if (searchTerm.length < 3)
        return true;

      if (credit.title.toUpperCase()
        .includes(searchTerm.toUpperCase())
        || credit.user.name.toUpperCase()
          .includes(searchTerm.toUpperCase()))
        return true;

      if (credit.user.name.toUpperCase()
        .includes(searchTerm.toUpperCase())
        || credit.user.name.toUpperCase()
          .includes(searchTerm.toUpperCase()))
        return true;

      return false;
    });
  }

  const visibleRefinancingCredits = getVisibleRefinancingCredits();

  return (
    <div>
      <Grid
        container
        justifyContent="flex-end"
        alignItems="flex-end"
        className={classes.filterBar}
        spacing={2}>
        {["administrator", "agent"].includes(userContext.user.role) &&
          <Grid item>
            <TextField
              className={classes.searchField}
              label="Zweck"
              value={subtypeFilter}
              onChange={(e) => {
                setSubtypeFilter(e.target.value);
              }}
              style={{ width: 150 }}
              select
            >
              <MenuItem value="">-</MenuItem>
              <MenuItem value="hauskauf">Hauskauf</MenuItem>
              <MenuItem value="wohnungskauf">Wohnungskauf</MenuItem>
              <MenuItem value="grundkauf">Grundkauf</MenuItem>
              <MenuItem value="hausbau">Hausbau</MenuItem>
              <MenuItem value="umbau">Umbau</MenuItem>
              <MenuItem value="umschuldung">Umschuldung</MenuItem>
            </TextField>
          </Grid>
        }
        {userContext.user.role === "administrator" &&
          <Grid item>
            <TextField
              className={classes.searchField}
              label="Finanzierungsberater"
              value={agentFilter}
              onChange={(e) => {
                setAgentFilter(e.target.value);
              }}
              style={{ width: 200 }}
              select
            >
              <MenuItem key={"agentfilter-empty"} value="">-</MenuItem>
              {availableAgents.map((option) => {
                return (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    disabled={option.active === false}
                    style={option.active === false ? { opacity: 0.5 } : {}}
                  >
                    {option.name}{option.active === false ? " (inaktives Profil)" : ""}
                  </MenuItem>
                )
              })}
            </TextField>
          </Grid>
        }
        <Grid item>
          <TextField
            placeholder="Suchen"
            className={classes.searchField}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>,
            }}
          />
        </Grid>
        <Grid item xs={12}>
        </Grid>
      </Grid>
      {
        visibleRefinancingCredits.map((credit) => {
          return renderCredit(credit);
        })
      }
      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          color="primary"
          size="small"
          startIcon={<GetAppIcon />}
          onClick={downloadPotentialRefinancingExcel}
          disabled={isExcelDownloading}
        >
          Excel download
        </Button>
      </Box>
      <Menu
        id="credit-menu"
        anchorEl={actionsMenuTarget}
        keepMounted
        open={Boolean(actionsMenuTarget)}
        onClose={() => { setActionsMenuTarget(null) }}
      >
        {getAvailableSnoozeMenuOptions(creditForActions).map((option) => (
          <MenuItem
            key={option.mode}
            onClick={() => setCreditSnooze(option.mode)}
          >
            <Typography variant="inherit">{option.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
        
      <Grid item>
        <ArchiveStatsDialog
          credit={creditForActions}
          open={archiveStatsOpen}
          setOpen={(open) => {
            setArchiveStatsOpen(open);
            if (open === false) {
              // refresh credits list on close
              props.getCredits();
            }
          }}
        />
      </Grid>
    </div>
  );
};

export default CreditsFiltered;
